"use client";

import React, { useState } from "react";
// import { BoldNavbar } from "../../ui/components/BoldNavbar";
import { BoldNavbarMobile } from "../../ui/components/BoldNavbarMobile";
import { Button } from "../../ui/components/Button";
import { IconWithBackground } from "../../ui/components/IconWithBackground";
import { Badge } from "../../ui/components/Badge";
import { BoldFooter } from "../../ui/components/BoldFooter";
import { useNavigate } from "react-router-dom";
import Figure from "components/Figure/Figure";
import { Colors, FigureData, Figures } from '../../types';
import AuthModal from "components/AuthModal/AuthModal";
import { BoldNavbar } from "ui";


function Landing() {
  const navigate = useNavigate();
  const [isSignUpOpen, setIsSignUpOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  const scrollToSection = (sectionId: string, center?: boolean) => {
    console.log('scrollto', sectionId);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: center ? "center" : "start",
      });
    }
  };

  return (
    <div className="flex h-full w-full flex-col items-start bg-default-background">
      <AuthModal open={isSignUpOpen} onOpenChange={setIsSignUpOpen} isSignUp={true} />
      <AuthModal open={isLoginOpen} onOpenChange={setIsLoginOpen} isSignUp={false} />

      {/* <div className="fixed top-0 left-0 z-50 w-full bg-default-background shadow-md">
        <div className="flex w-full flex-col items-center justify-center px-6 py-4"> */}
      {/* <BoldNavbar
            className="mobile:hidden"
            aboutClicked={() => scrollToSection("strategic-genius", true)}
            onLoginClicked={() => setIsLoginOpen(true)}
            onSignupClicked={() => setIsSignUpOpen(true)}
          />
          <BoldNavbarMobile
            className="hidden mobile:flex"
            aboutClicked={() => { scrollToSection("strategic-genius", true) }}
            onLoginClicked={() => { setIsLoginOpen(true) }}
            onSignupClicked={() => setIsSignUpOpen(true)} /> */}

      {/* </div>
      </div> */}

      <BoldNavbar aboutClicked={() => { scrollToSection("strategic-genius", true) }}/>

      <div id="chess-reimagined" className="flex min-h-screen w-full flex-col items-center justify-center gap-8 overflow-hidden bg-brand-900 px-6 py-32 relative mobile:px-4 mobile:py-24">
        <div className="flex items-start absolute inset-0 z-0">
          <img
            className="grow shrink-0 basis-0 self-stretch object-cover"
            src="https://i.imgur.com/X0nlfMX.png"
          />
        </div>
        <div className="flex w-full flex-col items-center gap-8 rounded-lg bg-brand-900 px-8 py-12 shadow-md relative z-10 backdrop-blur-sm mobile:px-4 mobile:py-12">
          <span className="w-full max-w-[768px] whitespace-pre-wrap font-['Montserrat'] text-[96px] font-[900] leading-[84px] text-white text-center -tracking-[0.04em] mobile:font-['Inter'] mobile:text-[48px] mobile:font-[800] mobile:leading-[44px] mobile:tracking-normal">
            {"CHESS REIMAGINED"}
          </span>
          <span className="max-w-[576px] whitespace-pre-wrap font-['Montserrat'] text-[20px] font-[600] leading-[28px] text-brand-100 text-center -tracking-[0.015em] mobile:font-['Inter'] mobile:text-[16px] mobile:font-[400] mobile:leading-[24px] mobile:tracking-normal">
            {
              "Customize your deck and go face to face against opponents. Your imagination is your only limit."
            }
          </span>
          <div className="flex flex-wrap items-center justify-center gap-6">
            <Button
              size="large"
              icon="FeatherPlay"
              onClick={(event: React.MouseEvent<HTMLButtonElement>) => { navigate("/signup") }}
            >
              Play Now
            </Button>
            <Button
              variant="brand-secondary"
              size="large"
              icon="FeatherCompass"
              onClick={(event: React.MouseEvent<HTMLButtonElement>) => { scrollToSection('pieces-section') }}
            >
              Explore Pieces
            </Button>
          </div>
        </div>
      </div>
      <div id="strategic-genius" className="flex w-full flex-col items-center justify-center gap-6 bg-brand-900 px-6 py-32 mobile:px-4 mobile:py-24">
        <div className="flex w-full max-w-[1280px] flex-wrap items-center justify-center gap-12 mobile:flex-row mobile:flex-wrap mobile:gap-8">
          <div className="flex grow shrink-0 basis-0 flex-col items-center justify-center gap-2 self-stretch">
            <div className="flex w-full min-w-[288px] max-w-[576px] grow shrink-0 basis-0 flex-col items-center justify-center gap-2">
              <img
                className="w-full grow shrink-0 basis-0 object-cover rounded-3xl"
                src="https://i.imgur.com/Z7I92Ub.png"
              />
            </div>
          </div>
          <div className="flex min-w-[320px] grow shrink-0 basis-0 flex-col items-start justify-center gap-24 self-stretch py-12 mobile:px-0 mobile:py-6">
            <div className="flex max-w-[576px] flex-col items-start justify-center gap-4">
              <span className="w-full max-w-[576px] font-['Montserrat'] text-[50px] font-[700] leading-[56px] text-brand-300 -tracking-[0.025em] mobile:font-['Inter'] mobile:text-[36px] mobile:font-[400] mobile:leading-[40px] mobile:tracking-normal">
                Unleash Your Strategic Genius
              </span>
              <span className="whitespace-pre-wrap font-['Montserrat'] text-[18px] font-[400] leading-[26px] text-white -tracking-[0.01em] mobile:font-['Inter'] mobile:text-[16px] mobile:font-[400] mobile:leading-[24px] mobile:tracking-normal">
                {
                  "Use pieces that teleport, transform, among other wacky things to outplay your opponent. Play a unique game, every game. Variants that challenge the very foundations of chess."
                }
              </span>
            </div>
            <div className="flex w-full flex-wrap items-start gap-6 flex-row justify-evenly">
              <div className="flex shrink-0 basis-0 flex-col items-center gap-2">
                <IconWithBackground
                  variant="success"
                  size="large"
                  icon="FeatherWand2"
                />
                <span className="whitespace-pre-wrap font-['Montserrat'] text-[16px] font-[500] leading-[24px] text-white">
                  {"Special Pieces"}
                </span>
              </div>
              <div className="flex shrink-0 basis-0 flex-col items-center gap-2">
                <IconWithBackground
                  variant="warning"
                  size="large"
                  icon="FeatherSwords"
                />
                <span className="whitespace-pre-wrap font-['Montserrat'] text-[16px] font-[500] leading-[24px] text-white">
                  {"PvP"}
                </span>
              </div>
              {/* <div className="flex min-w-[240px] grow shrink-0 basis-0 flex-col items-start gap-2">
                <IconWithBackground
                  variant="error"
                  size="large"
                  icon="FeatherTrophy"
                />
                <span className="whitespace-pre-wrap font-['Montserrat'] text-[16px] font-[500] leading-[24px] text-white">
                  {"Competitive Matches"}
                </span>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div id="pieces-section" className="flex w-full flex-col items-center justify-center gap-12 bg-default-background px-6 py-32 mobile:px-4 mobile:py-24">
        <div className="flex w-full max-w-[768px] flex-col items-center justify-center gap-4">
          <span className="font-['Montserrat'] text-[50px] font-[700] leading-[56px] text-default-font text-center -tracking-[0.025em] mobile:font-['Inter'] mobile:text-[36px] mobile:font-[400] mobile:leading-[40px] mobile:tracking-normal">
            New Pieces!
          </span>
          <span className="max-w-[576px] whitespace-pre-wrap font-['Montserrat'] text-[18px] font-[400] leading-[26px] text-subtext-color text-center -tracking-[0.01em] mobile:font-['Inter'] mobile:text-[16px] mobile:font-[400] mobile:leading-[24px] mobile:tracking-normal">
            {
              "Built for synergistic, compounding strength that doesn't throw strategy out the window."
            }
          </span>
        </div>
        <div className="flex w-full max-w-[1280px] items-center justify-center gap-6">
          <div className="flex w-full max-w-[1280px] flex-wrap items-center justify-center gap-6 mobile:flex-col">
            <div className="flex min-w-[288px] max-w-[300px] grow shrink-0 basis-0 flex-col items-start gap-8 rounded-[32px] bg-neutral-100 px-8 py-8">
              <Figure figureClicked={() => { }} figure={{
                id: 'jester',
                name: Figures.JESTER,
                x: 0,
                y: 0,
                color: Colors.WHITE
              }}
                relativePos />
              <div className="flex w-full flex-col items-start gap-2">
                <div className="flex flex-row items-start items-center gap-2">
                  <Badge>Other</Badge>
                  <span className="font-['Montserrat'] text-[24px] font-[700] leading-[32px] text-default-font">
                    Jester
                  </span>
                </div>
                <span className="font-['Montserrat'] text-[16px] font-[400] leading-[24px] text-subtext-color">
                  Moves one square in any direction, like a King. When an opponent’s piece is able to capture the Jester, that piece’s options are limited—it can only move to capture the Jester, ignoring all other moves until it does so or the Jester is out of sight.
                </span>
                {/* <div className="flex items-center gap-2 pt-4">
                  <Badge variant="success">Hot 🔥</Badge>
                  <Badge variant="neutral">5.0★</Badge>
                </div> */}
              </div>
            </div>
            <div className="flex min-w-[288px] max-w-[300px] grow shrink-0 basis-0 flex-col items-start gap-8 rounded-[32px] bg-neutral-100 px-8 py-8">
              <Figure figureClicked={() => { }} figure={{
                id: 'checker',
                name: Figures.CHECKER,
                x: 0,
                y: 0,
                color: Colors.WHITE
              }}
                relativePos />
              <div className="flex w-full flex-col items-start gap-2">
                <div className="flex flex-row items-start items-center gap-2">
                  <Badge variant="success">Pawn</Badge>
                  <span className="font-['Montserrat'] text-[24px] font-[700] leading-[32px] text-default-font">
                    Checker
                  </span>
                </div>

                <span className="font-['Montserrat'] text-[16px] font-[400] leading-[24px] text-subtext-color">
                  Moves diagonally one square forward and captures by jumping over an opponent’s piece onto an empty square. Can chain multiple jumps on the same turn. If it starts a jump chain, it must finish it. Gets promoted to "Queen Checker" on reaching the opponent’s back row.
                </span>
                {/* <div className="flex items-center gap-2 pt-4">
                  <Badge>Featured</Badge>
                  <Badge variant="neutral">4.9★</Badge>
                </div> */}
              </div>
            </div>
            <div className="flex min-w-[288px] max-w-[300px] grow shrink-0 basis-0 flex-col items-start gap-8 rounded-[32px] bg-neutral-100 px-8 py-8">
              <Figure figureClicked={() => { }} figure={{
                id: 'mimic',
                name: Figures.MIMIC,
                x: 0,
                y: 0,
                color: Colors.WHITE
              }}
                relativePos />
              <div className="flex w-full flex-col items-start gap-2">
                <div className="flex flex-row items-start items-center gap-2">
                  <Badge>Other</Badge>
                  <span className="font-['Montserrat'] text-[24px] font-[700] leading-[32px] text-default-font">
                    Mimic
                  </span>
                </div>
                <span className="font-['Montserrat'] text-[16px] font-[400] leading-[24px] text-subtext-color">
                  Has no movement abilities of its own but can copy the abilities of any piece directly next to it. If adjacent to multiple pieces, it can choose from their movement options, making it versatile but dependent on nearby allies. You can't mimic a mimic!
                </span>
                {/* <div className="flex items-center gap-2 pt-4">
                  <Badge variant="warning">New</Badge>
                  <Badge variant="neutral">4.8★</Badge>
                </div> */}
              </div>
            </div>
          </div>

        </div>
        {/* <Button
          variant="neutral-primary"
          size="large"
          icon="FeatherArrowRight"
          onClick={(event: React.MouseEvent<HTMLButtonElement>) => { navigate("/pieces") }}
        >
          See All Pieces
        </Button> */}
      </div>
      <div id="ready-play" className="flex w-full flex-col items-center justify-center gap-6 bg-brand-900 px-6 py-32 mobile:px-4 mobile:py-24">
        <div className="flex w-full max-w-[1280px] flex-col items-center justify-center gap-8 rounded-[32px] bg-default-background px-6 pt-24 pb-16 mobile:px-4 mobile:py-16">
          <div className="flex w-full flex-col items-center justify-center gap-2">
            <span className="w-full max-w-[768px] whitespace-pre-wrap font-['Montserrat'] text-[72px] font-[900] leading-[68px] text-brand-900 text-center -tracking-[0.04em] mobile:font-['Inter'] mobile:text-[40px] mobile:font-[400] mobile:leading-[44px] mobile:tracking-normal">
              {"READY TO PLAY?"}
            </span>
            <span className="w-full max-w-[768px] whitespace-pre-wrap font-['Montserrat'] text-[20px] font-[500] leading-[28px] text-brand-900 text-center -tracking-[0.015em] mobile:font-['Inter'] mobile:text-[16px] mobile:font-[400] mobile:leading-[24px] mobile:tracking-normal">
              {"Join now for free and play now."}
            </span>
          </div>
          <Button
            size="large"
            icon="FeatherZap"
            onClick={(event: React.MouseEvent<HTMLButtonElement>) => { setIsSignUpOpen(true) }}
          >
            Start Your Journey
          </Button>
        </div>
      </div>
      <div className="flex w-full flex-col items-start">
        <BoldFooter />
      </div>
    </div>
  );
}

export default Landing;